<template>
	<div style="height: 100%;">
		<router-view></router-view>
	</div>
</template>

<script>
	// 发票管理（新）
	export default {
		name: 'InvoiceManagement',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
